import { Injectable } from '@angular/core';
import {TitleCasePipe} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class EstadosService {

  static readonly ESTADOS_GESTION_JORNADA: { [key: string]: string } = {
    EN_JORNADA: "Presente",
    FINALIZADA: "Terminada",
    ATRASADA: "Atrasada",
    AUSENTE: "Ausente",
    DIA_LIBRE: "Día Libre",
    CAPACITACION: "Capacitación",
    VACACIONES: "Vacaciones",
    LICENCIA: "Licencia",
    PLANIFICADA: "Planificada"
  };

  constructor(private titleCasePipe: TitleCasePipe) { }

  transformGestionJornadaEstado(estado: string): string {
    if(!estado)
      return '';

    if(EstadosService.ESTADOS_GESTION_JORNADA[estado])
      return EstadosService.ESTADOS_GESTION_JORNADA[estado];
    else
      return this.titleCasePipe.transform(estado.replace('_', ' '));
  }


}
